import React from 'react';
import SearchInput from '../../masters/onlinePackage/SearchInput';
import AMultiFieldSearchInput from '../../../../../components/AMultiFieldSearchInput/AMultiFieldSearchInput';
import { searchInputOptions } from './utils';

const FilterForm = ({
  getConfigsData,
  isPANIndiaConfig
}) => {

  const searchHandler = (searchParam) => getConfigsData({ filters: searchParam });

  return (
    isPANIndiaConfig
      ? <SearchInput
        placeholder={"Search by Academic Career"}
        searchInputValueHandler={(inputVal) => searchHandler({ academicCareerValue: inputVal })}
        onCancel={() => searchHandler({})}
      />
      : <AMultiFieldSearchInput
        options={searchInputOptions}
        searchHandler={(searchKey, searchVal) => searchHandler({ [searchKey]: searchVal })}
        crossHandler={(searchKey, searchVal) => searchHandler({ [searchKey]: searchVal })}
      />

  );
}

export default FilterForm;